import React, {Component} from 'react';
import axios from 'axios';
import ReservationList from "../../components/ReservationList/ReservationList";
import ReservationForm from "../../components/ReservationForm/ReservationForm";

class RoomDetails extends Component {

    constructor(props) {
        super(props);
        document.title = 'Room details';
    }

    state = {
        userDetails: JSON.parse(localStorage.getItem("user")),
        reservations: [],
        room: {
            id: 0,
            name: '',
            numberOfBeds: 0,
            pricePerNight: 0,
            description: '',
            imageUrl: ''
        },
        reservationFormData: {
            startDate: {
                value: '',
                isValid: true,
                message: ''
            },
            endDate: {
                value: '',
                isValid: true,
                message: ''
            },
            roomId: {
                value: -1,
                isValid: true,
                message: ''
            },
            guestName: {
                value: '',
                isValid: true,
                message: ''
            },
        }
    };

    goBack = () => {
        this.props.history.goBack();
    };


    inputChangeHandler = (event) => {
        const updatedReservationForm = {...this.state.reservationFormData};
        const updatedFormElement = {...updatedReservationForm[event.target.name]};
        updatedFormElement.value = event.target.value;
        updatedFormElement.isValid = 'true';
        updatedReservationForm[event.target.name] = updatedFormElement;
        this.setState({reservationFormData: updatedReservationForm});
    };

    getReservations = () => {
        axios.get('/api/rooms/' + this.props.match.params.id + '/reservations')

            .then(response => {
                console.log("getting reservations from back-end:", response.data);
                this.setState({
                    reservations: response.data.reservations
                });
            });
    };

    reservationSubmit = (event) => {
        event.preventDefault();
        let formData = {};
        for (let formElementId in this.state.reservationFormData) {
            if (this.state.reservationFormData.hasOwnProperty(formElementId)) {
                formData[formElementId] = this.state.reservationFormData[formElementId].value;
            }
        }

        if (this.state.userDetails.role !== "ROLE_ADMINISTRATOR") {
            formData = {
                ...formData,
                guestName: this.state.userDetails.name
            };
        }

        console.log("Logging userDetails from state:", this.state.userDetails);
        console.log("Logging form data with user id:", formData);

        let url = '/api/rooms/' + this.props.match.params.id + '/reservations';
        let method = 'post';

        if (this.state.reservationId) {
            url += '/' + this.state.reservationId;
            method = 'put';
        }

        const user = JSON.parse(localStorage.getItem('user'));

        if (user.role !== "ROLE_ADMINISTRATOR" ||
            (user.role === "ROLE_ADMINISTRATOR" && method === "put")) {
            axios({method: method, url: url, data: formData})
                .then((response) => {
                    if (user.role !== "ROLE_ADMINISTRATOR") {
                        this.props.history.push(response.data + '/confirm')
                    }
                    this.getReservations();
                    formData:null;
                }).catch(error => {
                console.warn('RoomDetails reservationSubmit error:', error);
                console.warn('RoomDetails reservationSubmit error.response:', error.response);
                this.validationHandler(error.response.data);
            });
        }

    };

    reservationEdit = (id, guestName, startDate, endDate) => {

        const monthDayFormat = (number) => {
            return number > 9 ? "" + number : "0" + number;
        };
        const startDateRightFormat = startDate[0] + "-" + monthDayFormat(startDate[1]) + "-" + monthDayFormat(startDate[2]);
        const endDateRightFormat = endDate[0] + "-" + monthDayFormat(endDate[1]) + "-" + monthDayFormat(endDate[2]);


        this.setState({
            reservationId: id,
            reservationFormData: {
                guestName: {
                    value: guestName,
                    isValid: true,
                    message: ''
                },
                startDate: {
                    value: startDateRightFormat,
                    isValid: true,
                    message: ''
                },
                endDate: {
                    value: endDateRightFormat,
                    isValid: true,
                    message: ''
                },
                roomId: {
                    value: this.props.match.params.id,
                    isValid: true,
                    message: ''
                }
            }
        });

    };

    deleteReservationHandler = (id) => {
        console.log("deleteReservationHandler: ", "/api/rooms/" + this.props.match.params.id + "/reservations/" + id)
        axios.delete("/api/rooms/" + this.props.match.params.id + "/reservations/" + id)
            .then(response => {
                console.log(response);
                this.componentDidMount();
            })
            .catch(error => {
                console.warn(error.response);
            });
    };

    validationHandler = (error) => {
        const updatedReservationForm = {...this.state.reservationFormData};

        for (let field in this.state.reservationFormData) {
            const updatedFormElement = {
                ...updatedReservationForm[field]
            };
            updatedFormElement.isValid = true;
            updatedFormElement.message = '';
            updatedReservationForm[field] = updatedFormElement;
        }

        for (let fieldError of error.fieldErrors) {
            const updatedFormElement = {
                ...updatedReservationForm[fieldError.field]
            };
            updatedFormElement.isValid = false;
            updatedFormElement.message = fieldError.message;
            updatedReservationForm[fieldError.field] = updatedFormElement;
        }
        this.setState({reservationFormData: updatedReservationForm});
    };

    componentDidMount() {
        axios.get('/api/rooms/' + this.props.match.params.id)
            .then(response => {
                console.log("Logging local storage item:", localStorage.getItem("user"));
                this.setState({
                    room: response.data
                });
            });

        this.getReservations();

        if (this.state.reservationFormData.roomId.value !== this.props.match.params.id) {
            const updatedReservationForm = {...this.state.reservationFormData};
            const updatedRoomIdElement = {...updatedReservationForm.roomId};
            updatedRoomIdElement.value = this.props.match.params.id;
            updatedReservationForm.roomId = updatedRoomIdElement;
            this.setState({reservationFormData: updatedReservationForm});
        }
    }


    render() {
        let imgUrl;
        if (this.state.room.imageUrl === null || this.state.room.imageUrl.trim() === '') {
            imgUrl = '/images/noimage.png';
        } else {
            imgUrl = this.state.room.imageUrl;
        }

        return (
            <div>
                <h2>{this.state.room.name}</h2>
                <hr/>
                <div className="container">
                    <div className="card">
                        <div className="row">

                            <div className="col-lg-6 align-content-lg-center">
                                <img className="img-fluid" src={imgUrl} alt="Room"/>
                            </div>
                            <div className="card-body col-lg-6 text-left">

                                <h3 className="title col-sm-8">{this.state.room.name} </h3>
                                <p className="col-sm-8">{this.state.room.numberOfBeds} beds</p>
                                <p className="col-sm-8">Price per night: {this.state.room.pricePerNight} $</p>

                                <hr/>
                                <p className="col-sm-8">{this.state.room.description}</p>

                                <button className="btn btn-primary" onClick={() => this.props.history.push('/')}>
                                    Go back to previous page
                                </button>
                            </div>
                        </div>
                    </div>

                    {this.state.userDetails.role === 'ROLE_USER' ?
                        <ReservationList reservations={this.state.reservations}
                                         reservationEdit={this.reservationEdit}
                                         deleteHandler={this.deleteReservationHandler}/>
                        : ''}
                    <ReservationForm reservationFormData={this.state.reservationFormData}
                                     inputChangeHandler={this.inputChangeHandler}
                                     reservationSubmit={this.reservationSubmit}
                                     validationHandler={this.validationHandler}/>
                </div>
            </div>
        )
    }
}

export default RoomDetails;



// WEBPACK FOOTER //
// ./src/containers/RoomDetails/RoomDetails.jsx